import { Deserializable } from './deserializable.model';

export interface LineItemSku {
  sku: string;
  bundledItemSku?: string;
}

export class PaymentRefund implements Deserializable<PaymentRefund> {
  amount: number;
  refundDate: Date;
  notes: string;
  skus: LineItemSku[];

  constructor(input?: any) {
    if (input) {
      this.deserialize(input);
    }
  }

  deserialize(input: any): PaymentRefund {
    return Object.assign(this, input);
  }
}
